// extracted by css-extract-rspack-plugin
export default {"logoWithWordmarkHeader":"UwtYnDUqyP42C_zT","logoHeader":"o4hn4RmYfIMRaBXf","dark":"CWJuSussXCA0UNUl","noBackground":"OYorcbPAA_cYNkhl"};